@if (!(isLoaded | async)) {
  <div class="column-header-group">&nbsp;</div>
}
@if (isLoaded | async) {
  <div class="column-header-group">
    @for (ch of columnHeaders; track ch) {
      <div #columnRefs [ngClass]="ch.class">
        @if (ch.sortable) {
          <span (click)="onClickColumn(ch)" [class.active]="ch.active" [class.up]="uiDirection === 1"
            [class.down]="uiDirection === -1">
            {{ch.labelKey | translate}}<span class="fas fa-fw"></span>
          </span>
        }
        @if (!ch.sortable) {
          <span>
            {{ch.labelKey | translate}}
          </span>
        }
      </div>
    }
  </div>
}
